module.exports = __webpack_public_path__ + "static/media/menu-mobile.e09cdc1d.svg";